import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';
import { IPageDataViewModel } from 'src/app/share/pages/pages';
import { Observable, of, merge } from 'rxjs';
import { map, catchError, switchMap, delay } from 'rxjs/operators';
import { CommonService } from 'src/app/share/services/common.service';
import { DateUtil } from 'src/app/share/utils/date-util';
import { FormInputComponent, IFormInputViewModel } from 'src/app/share/forms/form-input/form-input.component';
import { Router } from '@angular/router';
import { IAtInfo, IBreak, IBreakInfo, IDriverBreakDay, IRow, ITimesheetIssue } from '../payroll-break/payroll-break.component';
import { StringifyOptions } from 'querystring';

@Component({
  selector: 'app-timesheets',
  templateUrl: './timesheets.component.html',
  styleUrls: ['./timesheets.component.scss']
})
export class TimesheetsComponent implements OnInit {

  constructor(private commonService: CommonService, protected route: ActivatedRoute, private router: Router, private location: Location) { }

  vm$: Observable<IViewModelTimesheet>;

  ngOnInit(): void {
    const sheetId: number = Number(this.route.snapshot.paramMap.get("sheetId"));
    this.vm$ = this.getDataForEdit$(sheetId);
  }

  private getDataForEdit$(sheetId: number): Observable<IViewModelTimesheet> {
    const initial$ = of({
      workingText: 'Loading Data...',
      timesheetVm: {
        data: {
          payrollPeriodDriverDayTimesheetId: 0,
          signedDateTimeLocal: new Date(),
          driverBreakDay: null,
          editAllowed: false
        },
        payrollInfo: {
          payrollDate: '',
          driverNumber: '',
          driverName: '',
          payrollPeriodDriverDayId: 0,
          issuesCount: 0,
          issuesJson: '',
          issues: {} as ITimesheetIssue,
          payrollPeriodLocked: 0,
          totalDayMinutes: 0,
          payrollPeriodDriverId: 0
        },
        inputViewModel: undefined,
        inputRestViewModel: undefined,
        inputMealViewModel: undefined,
        numberOfRestBlocks: 0,
        numberOfMealBlocks: 0,
        checkboxRestAgree: false,
        checkboxRestDisagree: false,
        checkboxMealAgree: false,
        checkboxMealDisagree: false,
        inputMyTripsViewModel: undefined,
        checkboxReportIssues: false,
        checkboxSignAgree: false,
        checkboxSignDisagree: false,
        inputSignViewModel: undefined,
        mealMessage: undefined
      },
      sheetId: sheetId,
      signMessage: undefined
      //disclaimerAccepted: false
    });

    const loader$ = this.commonService.getData('PageCommand', 'home', 'get-timesheet-by-id', { sheetId: sheetId }, '/api/ChauffeurPortal').pipe(
      map((v: IViewModelTimesheet) => {
        if (v.workingText)
          return { ...v };

        const ret = { ...v, actionsAllowed: true };

        ret.timesheetVm = undefined
        ret.signMessage = undefined;
        if (ret.data?.timesheet) {
          ret.timesheetVm = {
            data: {
              payrollPeriodDriverDayTimesheetId: ret.data.timesheet.payrollPeriodDriverDayTimesheetId,
              signedDateTimeLocal: ret.data.timesheet.signedDateTimeLocal,
              driverBreakDay: JSON.parse(ret.data.timesheet.dataJson),
              editAllowed: ret.data.timesheet.editAllowed
            },
            inputViewModel: undefined,
            inputRestViewModel: undefined,
            inputMealViewModel: undefined,
            numberOfRestBlocks: 0,
            numberOfMealBlocks: 0,
            checkboxRestAgree: false,
            checkboxRestDisagree: false,
            checkboxMealAgree: false,
            checkboxMealDisagree: false,
            inputMyTripsViewModel: undefined,
            checkboxReportIssues: false,
            checkboxSignAgree: false,
            checkboxSignDisagree: false,
            inputSignViewModel: undefined,
          };
        }
        if (ret.data?.payrollInfo) {
          if (!ret.timesheetVm)
            ret.timesheetVm = {
              inputViewModel: undefined, numberOfRestBlocks: 0, numberOfMealBlocks: 0, checkboxRestAgree: false,
              checkboxRestDisagree: false, inputRestViewModel: undefined, inputMyTripsViewModel: undefined, checkboxReportIssues: false,
              checkboxMealAgree: false, checkboxMealDisagree: false, inputMealViewModel: undefined,
              checkboxSignAgree: false, checkboxSignDisagree: false, inputSignViewModel: undefined
            };
          ret.timesheetVm.payrollInfo = {
            payrollDate: DateUtil.shortDateTimeLocal(ret.data.payrollInfo.payrollDate, false),
            driverNumber: ret.data.payrollInfo.driverNumber,
            driverName: ret.data.payrollInfo.driverName,
            payrollPeriodDriverDayId: ret.data.payrollInfo.payrollPeriodDriverDayId,
            issuesCount: ret.data.payrollInfo.issuesCount,
            issues: JSON.parse(ret.data.payrollInfo.issuesJson),
            payrollPeriodLocked: ret.data.payrollInfo.payrollPeriodLocked,
            totalDayMinutes: ret.data.payrollInfo.totalDayMinutes,
            payrollPeriodDriverId: ret.data.payrollInfo.payrollPeriodDriverId
          };

        }
        if (!ret.timesheetVm)
          ret.timesheetVm = {
            inputViewModel: undefined, numberOfRestBlocks: 0, numberOfMealBlocks: 0, checkboxRestAgree: false,
            checkboxRestDisagree: false, inputRestViewModel: undefined, inputMyTripsViewModel: undefined, checkboxReportIssues: false,
            checkboxMealAgree: false, checkboxMealDisagree: false, inputMealViewModel: undefined,
            checkboxSignAgree: false, checkboxSignDisagree: false, inputSignViewModel: undefined
          };
        ret.timesheetVm.inputViewModel = this.buildInputViewModel('', false);
        ret.timesheetVm.inputRestViewModel = this.buildInputViewModel('', true);
        ret.timesheetVm.inputMealViewModel = this.buildInputViewModel('', true);
        ret.timesheetVm.inputMyTripsViewModel = this.buildInputViewModel('', true);
        ret.timesheetVm.inputSignViewModel = this.buildInputViewModel('', true);
        if (ret.timesheetVm?.payrollInfo?.payrollPeriodLocked)
          ret.timesheetVm.inputReportIssueViewModel = this.buildInputViewModel('', false);
        ret.timesheetVm.numberOfRestBlocks = ret.timesheetVm.data.driverBreakDay.restBreakInfo.windows.filter(w => w.isShort == false).length;
        ret.timesheetVm.numberOfMealBlocks = ret.timesheetVm.data.driverBreakDay.mealBreakInfo.windows.filter(w => w.isShort == false).length;
        ret.timesheetVm.mealMessage = undefined;
        ret.sheetId = sheetId;
        //ret.disclaimerAccepted = false;
        if (ret.timesheetVm?.payrollInfo?.payrollPeriodLocked || ret.timesheetVm?.data?.driverBreakDay?.signInfo) {
          ret.timesheetVm.checkboxReportIssues = ret.timesheetVm?.data?.driverBreakDay?.dayInfo?.reviewInfo?.reportIssues ?? false;
          ret.timesheetVm.inputMyTripsViewModel.data.comments = ret.timesheetVm?.data?.driverBreakDay?.dayInfo?.reviewInfo?.comment ?? '';

          ret.timesheetVm.checkboxRestAgree = ret.timesheetVm?.data?.driverBreakDay?.restBreakInfo?.reviewInfo?.agree ?? false;
          ret.timesheetVm.checkboxRestDisagree = ret.timesheetVm?.data?.driverBreakDay?.restBreakInfo?.reviewInfo?.disagree ?? false;
          ret.timesheetVm.inputRestViewModel.data.comments = ret.timesheetVm?.data?.driverBreakDay?.restBreakInfo?.reviewInfo?.comment ?? '';

          ret.timesheetVm.checkboxMealAgree = ret.timesheetVm?.data?.driverBreakDay?.mealBreakInfo?.reviewInfo?.agree ?? false;
          ret.timesheetVm.checkboxMealDisagree = ret.timesheetVm?.data?.driverBreakDay?.mealBreakInfo?.reviewInfo?.disagree ?? false;
          ret.timesheetVm.inputMealViewModel.data.comments = ret.timesheetVm?.data?.driverBreakDay?.mealBreakInfo?.reviewInfo?.comment ?? '';

          ret.timesheetVm.checkboxSignAgree = ret.timesheetVm?.data?.driverBreakDay?.signInfo?.reviewInfo?.agree ?? false;
          ret.timesheetVm.checkboxSignDisagree = ret.timesheetVm?.data?.driverBreakDay?.signInfo?.reviewInfo?.disagree ?? false;
          ret.timesheetVm.inputSignViewModel.data.comments = ret.timesheetVm?.data?.driverBreakDay?.signInfo?.reviewInfo?.comment ?? '';

          ret.timesheetVm.inputViewModel.commentsInputVm.isLocked = true;
          ret.timesheetVm.inputViewModel.data.comments = ret.timesheetVm?.data?.driverBreakDay?.signInfo?.comment ?? '';
        }
        if (!ret.timesheetVm?.payrollInfo?.payrollPeriodLocked && !ret.timesheetVm?.data?.driverBreakDay?.signInfo) {
          // lets validate meal breaks
          (ret.timesheetVm.data.driverBreakDay.mealBreakInfo.breaksBefore ?? []).forEach(w => {
            this.validateBreakTimes(w, ret.timesheetVm.data);
          });
          (ret.timesheetVm.data.driverBreakDay.mealBreakInfo.windows ?? []).forEach(w => {
            (w.breaks ?? []).forEach(b => {
              this.validateBreakTimes(b, ret.timesheetVm.data);
            });
          });
          (ret.timesheetVm.data.driverBreakDay.mealBreakInfo.breaksAfter ?? []).forEach(w => {
            this.validateBreakTimes(w, ret.timesheetVm.data);
          });
        }
        console.log('timesheet', ret);
        return ret;
      })
    );
    return merge(initial$, loader$);
  }

  private executeAction$(vm: IViewModelTimesheet, actionName: string, paramData: any): Observable<IViewModelTimesheet> {
    return this.commonService.getData('PageCommand', 'home', actionName, paramData, '/api/ChauffeurPortal').pipe(
      map((r: IViewModelTimesheet) => {
        if (r.workingText)
          return { ...r, actionsAllowed: false };

        const ret: IViewModelTimesheet = { ...r, actionsAllowed: true };

        if (ret.data && ret.data.status == 'ok') {
          switch (actionName) {
            case 'sign-timesheet':
              vm.updateMessage = 'Timesheet signet successfully';
              break;
            case 'report-timesheet-issue':
              vm.updateMessage = 'Your issue has been reported to the Payroll Department.';
              break;
          }
        } else {
          switch (actionName) {
            case 'sign-timesheet':
              vm.errorMessage = ret.errorText ?? 'Error on signing timesheet';
              break;
            case 'report-timesheet-issue':
              vm.errorMessage = ret.errorText ?? 'There was an error submitting your issue to the Payroll Department.';
              break;
          }
        }
        console.log('executeAction', ret);
        return ret;
      }),
      catchError((e, v) => {
        const ret = { ...e };

        console.log('error', e);
        vm.errorMessage = e.errorText ?? 'Error executing action';

        return of(ret);
      })
    );
  }

  private setMealMessage(mbi: IBreakInfo, vm: IViewModelTimesheet): ICardMessage {
    let message: ICardMessage = {};

    if (this.isBreakTimeErrorsSet(vm)) {
      message.errorMessage = 'You must fix all errors to continue.';
    }

    if ((message?.errorMessage ?? '').length === 0) {
      const breakCount = (mbi?.windows ?? []).reduce((count, w) => {
        return count + (w.breaks?.length ?? 0);
      }, 0);
      const breakBeforeCount = (mbi?.breaksBefore ?? []).length;
      const breakAfterCount = (mbi?.breaksAfter ?? []).length;

      const blockCount = (mbi?.windows ?? []).filter(w => w.isShort === false).length;

      if (blockCount > 0 && breakCount + breakBeforeCount + breakAfterCount == 0) {
        message.errorMessage = `If you select 'agree' you must provide meal break start and end time.`;
      }
    }

    return message;
  }

  refreshPage() {
    const sheetId: number = Number(this.route.snapshot.paramMap.get("sheetId"));
    this.vm$ = this.getDataForEdit$(sheetId);
  }

  goBack() {
    this.location.back();
  }

  buildInputViewModel(comm: string, isLocked: boolean): ITimeSheetInputViewModel {
    const data = {
      comments: comm
    };

    const ret: ITimeSheetInputViewModel = {
      data: data,
      commentsInputVm: FormInputComponent.viewModel(data, 'comments', { title: 'Comments', type: 'textarea', isRequired: false, isLocked: isLocked }),
    };
    return ret;
  }

  async signTimeSheet(vm: IViewModelTimesheet) {
    vm.updateMessage = undefined;
    vm.errorMessage = undefined;
    vm.signMessage = undefined;

    if (vm.timesheetVm.checkboxReportIssues && (vm.timesheetVm.inputMyTripsViewModel?.data?.comments ?? '').length > 0) {
      vm.timesheetVm.data.driverBreakDay.dayInfo.reviewInfo = {
        reportIssues: true,
        comment: vm.timesheetVm.inputMyTripsViewModel.data.comments
      }
    }
    if (vm.timesheetVm.checkboxRestAgree || vm.timesheetVm.checkboxRestDisagree) {
      vm.timesheetVm.data.driverBreakDay.restBreakInfo.reviewInfo = {
        agree: vm.timesheetVm.checkboxRestAgree,
        disagree: vm.timesheetVm.checkboxRestDisagree,
        comment: vm.timesheetVm.inputRestViewModel?.data?.comments ?? ''
      }
    }
    if (vm.timesheetVm.checkboxMealAgree || vm.timesheetVm.checkboxMealDisagree) {
      vm.timesheetVm.data.driverBreakDay.mealBreakInfo.reviewInfo = {
        agree: vm.timesheetVm.checkboxMealAgree,
        disagree: vm.timesheetVm.checkboxMealDisagree,
        comment: vm.timesheetVm.inputMealViewModel?.data?.comments ?? ''
      }
    }
    if (vm.timesheetVm.checkboxSignAgree || vm.timesheetVm.checkboxSignDisagree || (vm.timesheetVm.inputViewModel?.data?.comments ?? '').length > 0) {
      vm.timesheetVm.data.driverBreakDay.signInfo = {
        comment: vm.timesheetVm.inputViewModel.data.comments,
        reviewInfo: {
          agree: vm.timesheetVm.checkboxSignAgree,
          disagree: vm.timesheetVm.checkboxSignDisagree,
          comment: vm.timesheetVm.inputSignViewModel?.data?.comments ?? ''
        }
      }
    }

    var jsonSignString: string = JSON.stringify(vm.timesheetVm.data.driverBreakDay);

    const timesheetDataItems = await of({}).pipe(
      delay(100),
      switchMap(() => this.executeAction$(vm, 'sign-timesheet', { sheetId: vm.sheetId, jsonSign: jsonSignString, payrollPeriodDriverId: vm.timesheetVm.payrollInfo.payrollPeriodDriverId }))
    ).toPromise();

    if ((timesheetDataItems?.errorText ?? '').length > 0) {
      vm.signMessage = timesheetDataItems.errorText;
      return;
    }
    if ((timesheetDataItems?.data?.status ?? 'error') == 'ok' && vm.errorMessage == undefined)
      this.goBack();
  }

  addBreakClicked(breakId: number, vm: IViewModelTimesheet) {
    if (vm.timesheetVm.payrollInfo.payrollPeriodLocked)
      return;
    if ((vm.timesheetVm?.payrollInfo?.payrollDate ?? '').length > 0) {
      var payrollDate = vm.timesheetVm.payrollInfo.payrollDate;
      var dayId = vm.timesheetVm.payrollInfo.payrollPeriodDriverDayId;
      this.router.navigate(['/payroll/breaks', breakId], {
        queryParams: { dayId, payrollDate }
      });
    }
  }

  editBreakTimeClicked(breakId: number, vm: IViewModelTimesheet) {
    if (vm.timesheetVm.payrollInfo.payrollPeriodLocked)
      return;
    this.router.navigateByUrl(`/payroll/breaks/${breakId}`);
  }

  getLabel(subTitle: string, title: string): string {
    if (title == 'Reporting Time')
      return 'Start of Shift';
    const clean = (value: string): string =>
      value ? value.split(',')[0].trim() : '';

    const cleanSub = clean(subTitle);
    const cleanTitle = clean(title);

    return cleanSub ? `${cleanSub} - ${cleanTitle}` : cleanTitle;
  }

  getIssues(issues: ITimesheetIssue): string[] {
    const issuesArr: string[] = [];

    if (issues?.notPriced) {
      issuesArr.push('This day is not priced');
    }

    if (issues?.dayTooLong) {
      issuesArr.push('The day is too long');
    }

    return issuesArr;
  }

  formatMinutes(totalMinutes: number): string {
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    const hourLabel = hours === 1 ? 'hour' : 'hours';
    const minuteLabel = minutes === 1 ? 'minute' : 'minutes';

    return `${hours} ${hourLabel} and ${minutes} ${minuteLabel}`;
  }

  onRestAgreeChange(ts: ITimeSheetViewModel): void {
    if (ts.checkboxRestAgree) {
      ts.checkboxRestDisagree = false;
      ts.inputRestViewModel.commentsInputVm.isLocked = true;
      ts.inputRestViewModel.commentsInputVm.isRequired = false;
      ts.inputRestViewModel.data.comments = '';
    }
  }

  onRestDisagreeChange(ts: ITimeSheetViewModel): void {
    if (ts.checkboxRestDisagree)
      ts.checkboxRestAgree = false;
    ts.inputRestViewModel.commentsInputVm.isLocked = ts.checkboxRestDisagree ? false : true;
    ts.inputRestViewModel.commentsInputVm.isRequired = ts.checkboxRestDisagree ? true : false;
  }

  onMealAgreeChange(ts: ITimeSheetViewModel, vm: IViewModelTimesheet): void {

    if (ts.checkboxMealAgree) {

      const mealMessage = this.setMealMessage(ts.data.driverBreakDay.mealBreakInfo, vm);
      if (mealMessage.errorMessage) {
        ts.mealMessage = mealMessage;
        ts.checkboxMealAgree = false;
      } else {
        ts.mealMessage = undefined;
      }

      ts.checkboxMealDisagree = false;
      ts.inputMealViewModel.commentsInputVm.isLocked = true;
      ts.inputMealViewModel.commentsInputVm.isRequired = false;
      ts.inputMealViewModel.data.comments = '';
    }
  }

  setBreakDuration(b: IBreak): number {
    if ((b.startAt?.date ?? '').length == 0 || (b.startAt?.time ?? '').length == 0
      || (b.endAt?.date ?? '').length == 0 || (b.endAt?.time ?? '').length == 0)
      return 0;

    const startDate = DateUtil.buildDateFromDateTimeString(b.startAt.date, b.startAt.time);
    const endDate = DateUtil.buildDateFromDateTimeString(b.endAt.date, b.endAt.time);

    const duration = DateUtil.getDurationInMinutes(startDate, endDate);

    if (duration == null || isNaN(duration)) {
      return 0;
    }
    return duration;
  }

  onMealDisagreeChange(ts: ITimeSheetViewModel): void {
    if (ts.checkboxMealDisagree) {
      ts.checkboxMealAgree = false;
      ts.mealMessage = undefined;
    }
    ts.inputMealViewModel.commentsInputVm.isLocked = ts.checkboxMealDisagree ? false : true;
    ts.inputMealViewModel.commentsInputVm.isRequired = ts.checkboxMealDisagree ? true : false;
  }

  onSignAgreeChange(ts: ITimeSheetViewModel): void {
    if (ts.checkboxSignAgree) {
      ts.checkboxSignDisagree = false;
      ts.inputSignViewModel.commentsInputVm.isLocked = true;
      ts.inputSignViewModel.commentsInputVm.isRequired = false;
      ts.inputSignViewModel.data.comments = '';
    }
  }

  onSignDisagreeChange(ts: ITimeSheetViewModel): void {
    if (ts.checkboxSignDisagree)
      ts.checkboxSignAgree = false;
    ts.inputSignViewModel.commentsInputVm.isLocked = ts.checkboxSignDisagree ? false : true;
    ts.inputSignViewModel.commentsInputVm.isRequired = ts.checkboxSignDisagree ? true : false;
  }

  onReportIssueshange(ts: ITimeSheetViewModel): void {
    ts.inputMyTripsViewModel.commentsInputVm.isLocked = ts.checkboxReportIssues ? false : true;
    ts.inputMyTripsViewModel.commentsInputVm.isRequired = ts.checkboxReportIssues ? true : false;
    if (!ts.checkboxReportIssues)
      ts.inputMyTripsViewModel.data.comments = '';
  }

  enableSignButton(vm: IViewModelTimesheet): boolean {
    if (vm.timesheetVm.payrollInfo && vm.timesheetVm.payrollInfo.issuesCount > 0)
      return true;
    if (vm.timesheetVm?.payrollInfo?.payrollPeriodLocked)
      return true;
    // if (!vm.disclaimerAccepted)
    //   return true;
    if (!vm.timesheetVm?.checkboxRestAgree && !vm.timesheetVm?.checkboxRestDisagree)
      return true;
    if (!vm.timesheetVm?.checkboxMealAgree && !vm.timesheetVm?.checkboxMealDisagree)
      return true;
    if (vm.timesheetVm?.checkboxRestDisagree && (vm.timesheetVm?.inputRestViewModel?.data?.comments ?? '').length == 0)
      return true;
    if (vm.timesheetVm?.checkboxMealDisagree && (vm.timesheetVm?.inputMealViewModel?.data?.comments ?? '').length == 0)
      return true;
    if (vm.timesheetVm?.checkboxReportIssues && (vm.timesheetVm?.inputMyTripsViewModel?.data?.comments ?? '').length == 0)
      return true;
    if (!vm.timesheetVm?.checkboxSignAgree && !vm.timesheetVm?.checkboxSignDisagree)
      return true;
    if (vm.timesheetVm?.checkboxSignDisagree && (vm.timesheetVm?.inputSignViewModel?.data?.comments ?? '').length == 0)
      return true;
    if (this.isBreakTimeErrorsSet(vm))
      return true;

    if ((vm.timesheetVm?.mealMessage?.errorMessage ?? '').length > 0)
      return true;

    return false;
  }

  isBreakTimeErrorsSet(vm: IViewModelTimesheet): boolean {
    {
      const errorCount = (vm.timesheetVm?.data?.driverBreakDay?.mealBreakInfo?.windows ?? [])
        .reduce((total, w) => {
          const breaks = w.breaks ?? [];
          const count = breaks.filter(b => b.errorText?.length > 0).length;
          return total + count;
        }, 0);
      if ((errorCount ?? 0) > 0)
        return true;
    }
    {
      const errorCount = (vm.timesheetVm?.data?.driverBreakDay?.mealBreakInfo?.breaksBefore ?? [])
        .filter(b => b.errorText?.length > 0).length;
      if ((errorCount ?? 0) > 0)
        return true;
    }
    {
      const errorCount = (vm.timesheetVm?.data?.driverBreakDay?.mealBreakInfo?.breaksAfter ?? [])
        .filter(b => b.errorText?.length > 0).length;
      if ((errorCount ?? 0) > 0)
        return true;
    }
    return false;
  }

  async submitReportIssue(vm: IViewModelTimesheet) {
    vm.updateMessage = undefined;
    vm.errorMessage = undefined;

    if ((vm.timesheetVm.inputReportIssueViewModel?.data?.comments ?? '').length == 0)
      return;

    vm.timesheetVm.data.driverBreakDay.timesheetIssueInfo = {
      comment: vm.timesheetVm.inputReportIssueViewModel.data.comments
    };

    var jsonSignString: string = JSON.stringify(vm.timesheetVm.data.driverBreakDay);

    const timesheetDataItems = await of({}).pipe(
      delay(100),
      switchMap(() => this.executeAction$(vm, 'report-timesheet-issue', { sheetId: vm.sheetId, jsonSign: jsonSignString }))
    ).toPromise();
  }

  validateBreakTimes(b: IBreak, d: ITimeSheetData) {

    if ((b.startAt?.date ?? '').length > 0 && (b.startAt?.time ?? '').length > 0 &&
      ((b.endAt?.date ?? '').length == 0 || (b.endAt?.time ?? '').length == 0)) {
      b.errorText = 'Break end time is missing.';
      return;
    }

    if (!b.startAt?.date || !b.startAt?.time || !b.endAt?.date || !b.endAt?.time) {
      return; // if any of the break times are not set, we cannot validate
    }

    b.durationMinutes = this.setBreakDuration(b);

    const breakStartDate = DateUtil.buildDateFromDateTimeString(b.startAt.date, b.startAt.time);
    const breakEndDate = DateUtil.buildDateFromDateTimeString(b.endAt.date, b.endAt.time);

    const rows = d?.driverBreakDay?.dayInfo?.rows ?? [];

    // Get shift start and end
    const shiftStart = DateUtil.buildDateFromDateTimeString(rows[0].fromInfo.at.date, rows[0].fromInfo.at.time);
    const shiftEnd = DateUtil.buildDateFromDateTimeString(rows[rows.length - 1].toInfo.at.date, rows[rows.length - 1].toInfo.at.time);

    // Reject if break is outside of shift hours
    if (breakStartDate < shiftStart || breakEndDate > shiftEnd) {
      b.errorText = 'Break time is outside of shift hours.';
      return;
    }

    // now we need to build busy trip times based on My Trips for the day
    const busyTimes = rows
      .filter(r =>
        r.fromInfo?.at?.date && r.fromInfo?.at?.time &&
        r.toInfo?.at?.date && r.toInfo?.at?.time
      )
      .map(r => ({
        start: DateUtil.buildDateFromDateTimeString(r.fromInfo.at.date, r.fromInfo.at.time),
        end: DateUtil.buildDateFromDateTimeString(r.toInfo.at.date, r.toInfo.at.time)
      }));

    // now we build free time ranges between trips
    const freeTimes = [];
    for (let i = 0; i <= (busyTimes ?? []).length; i++) {
      const prevEnd = i === 0 ? null : busyTimes[i - 1].end;
      const nextStart = i === busyTimes.length ? null : busyTimes[i].start;

      if (prevEnd && nextStart && prevEnd < nextStart) {
        freeTimes.push({ start: prevEnd, end: nextStart });
      }
    }

    // finaly we check if the break fits inside one of the free ranges
    const overlaps = (freeTimes ?? []).some(free => breakStartDate < free.end && breakEndDate > free.start);

    if (overlaps) {
      b.errorText = 'Break time overlaps with a trip.';
      return
    }

    if (b.durationMinutes > 90) {
      b.warningText = 'Break time seems long — please review meal break.'
      return;
    }
  }
}

/**
 * 
 */
interface IViewModelTimesheet extends IPageDataViewModel {
  data?: {
    timesheet?: { dataJson: string, editAllowed: boolean, payrollPeriodDriverDayTimesheetId: number, signedDateTimeLocal: Date },
    payrollInfo?: {
      payrollDate: Date,
      driverNumber: string,
      driverName: string,
      payrollPeriodDriverDayId: number,
      issuesCount: number,
      issuesJson: string,
      payrollPeriodLocked: number,
      totalDayMinutes: number,
      payrollPeriodDriverId: number
    },
    status?: string;
  };

  timesheetVm: ITimeSheetViewModel;

  sheetId: number;

  updateMessage?: string;
  errorMessage?: string;
  signMessage: string;
}

/**
 * 
 */
interface ITimeSheetViewModel {
  data?: ITimeSheetData;
  payrollInfo?: {
    payrollDate: string,
    driverNumber: string,
    driverName: string,
    payrollPeriodDriverDayId: number,
    issuesCount: number,
    issues: ITimesheetIssue,
    payrollPeriodLocked: number,
    totalDayMinutes: number,
    payrollPeriodDriverId: number
  };

  checkboxRestAgree: boolean;
  checkboxRestDisagree: boolean;
  checkboxReportIssues: boolean;
  checkboxMealAgree: boolean;
  checkboxMealDisagree: boolean;
  checkboxSignAgree: boolean;
  checkboxSignDisagree: boolean;

  inputViewModel?: ITimeSheetInputViewModel;
  inputRestViewModel?: ITimeSheetInputViewModel;
  inputMyTripsViewModel?: ITimeSheetInputViewModel;
  inputReportIssueViewModel?: ITimeSheetInputViewModel;
  inputMealViewModel?: ITimeSheetInputViewModel;
  inputSignViewModel?: ITimeSheetInputViewModel;

  numberOfRestBlocks: number;
  numberOfMealBlocks: number;

  mealMessage?: ICardMessage;
}

/**
 * 
 */
interface ICardMessage {
  errorMessage?: string;
  warningMessage?: string;
  infoMessage?: string;
}

/**
 * 
 */
interface ITimeSheetInputViewModel {
  data: ITimeSheetInputData;

  commentsInputVm: IFormInputViewModel;
}

/**
 * 
 */
interface ITimeSheetInputData {
  comments: string;
}

interface ITimeSheetData {
  payrollPeriodDriverDayTimesheetId: number;
  signedDateTimeLocal: Date;
  driverBreakDay: IDriverBreakDay;
  editAllowed: boolean
}


